var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 33,
    viewBox: "0 0 30 33",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_profile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.0004 14.5003C13.0671 14.5003 11.4421 13.842 10.1254 12.5253C8.80872 11.2086 8.15039 9.58363 8.15039 7.65029C8.15039 5.71696 8.80872 4.09196 10.1254 2.77529C11.4421 1.45863 13.0671 0.800293 15.0004 0.800293C16.9337 0.800293 18.5587 1.45863 19.8754 2.77529C21.1921 4.09196 21.8504 5.71696 21.8504 7.65029C21.8504 9.58363 21.1921 11.2086 19.8754 12.5253C18.5587 13.842 16.9337 14.5003 15.0004 14.5003Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.35 20.8757C6.28333 21.659 4.2 22.784 2.1 24.2507L0 26.1932C0.281053 26.5126 0.57272 26.8234 0.875 27.1257C2.69167 28.9423 4.81667 30.3757 7.25 31.4257C9.68333 32.4757 12.2667 33.0007 15 33.0007C17.7667 33.0007 20.3583 32.4757 22.775 31.4257C25.1917 30.3757 27.3083 28.9423 29.125 27.1257C29.4273 26.8234 29.7189 26.5126 30 26.1932L27.95 24.2507C25.85 22.784 23.7583 21.659 21.675 20.8757C19.5917 20.0923 17.3667 19.7007 15 19.7007C12.6333 19.7007 10.4167 20.0923 8.35 20.8757Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.d87a9c0db48adbf054f0ab56110571e5.svg";
export { ForwardRef as ReactComponent };